import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const ZipFormWrapper = styled.div(
  ({ theme, formVisibility }) => css`
    display: contents;
    ${formVisibility === 'mobile' &&
    css`
      @media (min-width: ${theme.breakpoints.sm}) {
        display: none;
      }
    `}

    ${formVisibility === 'desktop' &&
    css`
      @media (max-width: ${theme.breakpoints.sm}) {
        display: none;
      }
    `}
  `
)
